import Vue from 'vue'
import Vuex from 'vuex'
import repository from './services/Repository'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    auth: null,
    cleanFilenames: [],
    uploadFiles: [],
    fileCommentIsLoading: false,
    formsProducts: [],
    brokerFilter: [],
    teamList: [],
    metaStatesFilter: [],
    currentTray: "",
    dataTable: [],
    dataTablePrograms: [],
    isloader: false,
    queryToFilter:"",
    countDataTable: null,
    countDataTablePrograms: null,
    thereFilterResults: true,
    updateFetchCreate: false,
    techList: [],
    tid: null,
    idTemporaly: null
  },
  mutations: {
    changeUpdateFetchCreate(state) {
      state.updateFetchCreate = !state.updateFetchCreate
    },
    setAuth (state, authData) {
      state.auth = authData
    },
    setIdTemporaly(state, idTemporalyData) {
      state.idTemporaly = idTemporalyData
    },
    setTid(state, tidData) {
      state.tid = tidData
    },
    setProgramaEstrategicoVuex(state, programaEstrategicoVuexData) {
      state.programaEstrategicoVuex = programaEstrategicoVuexData
    },
    setCleanFileNames(state, cleanFilename) {
      state.cleanFilenames = [...state.cleanFilenames, cleanFilename]
    },
    deleteFilename(state, index) {
      state.cleanFilenames.splice(index, 1)
    },
    setUploadFiles(state, uploadFile) {
      state.uploadFiles = [...state.uploadFiles, uploadFile]
    },
    deleteAllUploadCommentFiles(state) {
      state.uploadFiles = []
    },
    deleteUploadFile(state, index) {
      state.uploadFiles.splice(index, 1)
      state.cleanFilenames.splice(index, 1)
    },
    deleteMultifile(state, id) {
      const uploadFilesUpdated = []
      state.uploadFiles.forEach(uploadFile => {
        if(uploadFile.id != id) {
          uploadFilesUpdated.push(uploadFile)
        }
      })
      state.uploadFiles = uploadFilesUpdated
    },
    deleteUploadsFromProduct(state, productId) {
      const uploadFilesUpdated = []
      state.uploadFiles.forEach(uploadFile => {
        if(uploadFile.productId != productId) {
          uploadFilesUpdated.push(uploadFile)
        }
      })
      state.uploadFiles = uploadFilesUpdated
    },
    updateUploadFiles(state, newUploadFiles) {
      state.uploadFiles = newUploadFiles
    },
    clearFilenames(state) {
      state.cleanFilenames = []
    },
    updateIsLoadingCommentFile(state, value) {
      state.fileCommentIsLoading = value 
    },
    setFormsProducts(state, formsProducts) {
      state.formsProducts = formsProducts
    },
    setBrokerFilter(state, data) {
      state.brokerFilter = data
    },
    setTeamList(state, teamList) {
      state.teamList = teamList
    },
    setTechList(state, techList) {
      state.techList = techList
    },
    setMetaStatesFilter(state, metaStates) {
      state.metaStatesFilter = metaStates
    },
    setCurrentTray(state, currentTray) {
      state.currentTray = currentTray
    },
    setDataTable(state, data) {
      state.dataTable = data
    },
    setDataTablePrograms(state, data) {
      state.dataTablePrograms = data
    },
    setQueryFilters(state, data) {
      state.queryToFilter = data
    },
    setCountDataTable(state, count) {
      state.countDataTable = count
    },
    setCountDataTablePrograms(state, count) {
      state.countDataTablePrograms = count
    },
    setThereFilterResults(state, data) {
      state.thereFilterResults = data
    },
    setIsloader(state, isloader) {
      state.isloader = isloader
    },
  },
  actions: {
    async fetchFilterBroker({ commit }, page) {
      const { data } = await repository.private().get(`broker/business/assigned/?page=1&page_size=1000`);
      if (data.next != null) {
        fetchFilterBroker({ commit }, 2)
      }else {
        commit("setBrokerFilter", data.results);
      }
    },
    async fethMetaStatesFilter({commit}, tray) {
      const { data } = await repository.private().get(`quotation/metastates/${tray}/`);
      commit("setMetaStatesFilter", data)
    },
    async getListPage( { commit, state }, {page, querys} ) {
      const {data} = await repository.private().get(`/dashboard/${state.currentTray}?page=${page}&page_size=50${querys}`)
      commit("setDataTable", data.results)
      commit("setCountDataTable", data.count)
    },

    async getListPagePrograms( { commit, state }, {page, querys} ) {
      commit("setIsloader", true)
      const {data} = await repository.private().get(`/programs/${state.currentTray}?page=${page}&page_size=50${querys}`)
      commit("setDataTablePrograms", data.results)
      commit("setCountDataTablePrograms", data.count)
      commit("setIsloader", false)
    }
  }
})
